
/** by MVinfo / Walcledson de Paula 8/8/24w
 * p-menu.jsx
 * alterações 02/08/24
 * no PC manter o tamanho;
 * no Tablet ou Notebook com telas menores diminuir o tamanho do menu;
 * no celular, deve ficar grudado na parte inferior do celular;
 * alterações: 14/08/24 | 16h04
 * alterações: 22/09/24 | 17h23 - acrescentamos a condição TipoAtendimento (0=sem funcionário / 1=com funcionários) que mostra ou não mostra o menu Colaboradores;
 * alterações: 08/11/24 | 21h40 - acrescentamos o menu "Regras Atendimento" que inclui "Dias/Horários" e "Feriados que não atende". Tiramos "TipoAtendimento" do "Home" e trouxemos para cá também;
 * 
* src/app/agendexPrestador/components/menu/p_menu.jsx
*/

import React, { useState, useEffect, Component } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { a_getUserData } from '../../../../Services/a_userutils';

import imgLogomarca from '../../../../Assets/agendex/logoagendexadmin.png';
import imgLogoMini from '../../../../Assets/agendex/iconLogoAgendex.png';
import Icon from '@mdi/react'; // icone do material design icones pra padronizar o home do mobile/desktop (delphi) no web 2/7/24w
import { mdiHome, mdiAccountGroup , mdiStorefront , mdiShapePlus, mdiAccountCircle } from '@mdi/js'; // colaboradores

import './a_menu.css';

function AMenu(props) {
    const navigate = useNavigate();

    // verifica se é Mobile, tablet, NP, PC, etc
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const activeLink = "nav-link active";
    const inactiveLink = "nav-link text-black";

    const initialUserData = a_getUserData();
    // const [tipoAtendimento, setTipoAtendimento] = useState(initialUserData.tipoAtendimento); // 0 = não possui colaboradores, 1 = possui colaboradores


    return (
        <>
            {/* Menu lateral esquerdo para telas maiores */}
            {/* <div className={`d-flex flex-column flex-shrink-0 ${isMobile ? 'd-none' : 'p-3 bg-secondary'}`} id="menu"> */}
            <div className={`${isMobile ? 'd-none' : 'd-flex flex-column flex-shrink-0 p-3 bg-secondary'}`} id="menu">
                <a href="/app/prestador/home" className="d-flex align-items-center mb-3 mb-md-0 me-md-auto text-white text-decoration-none">
                    <img src={isMobile ? imgLogoMini : imgLogomarca} className="img-logo" alt="logo" /><br/>
                </a>
                <p></p>
                <ul className="nav nav-pills flex-column mb-auto">
                    <hr/>
                    <li className="nav-item">
                        <Link to="/app/admin/home" className={props.page === "home" ? activeLink : inactiveLink} aria-current="page">
                            <Icon path={mdiHome} size={1} className='me-2'
                                title="Página principal/Dashboard"/>Home
                        </Link> 
                    </li>
                    <li className="nav-item">
                        <Link to="/app/admin/clientes" className={props.page === "clientes" ? activeLink : inactiveLink} aria-current="page">
                            <Icon path={mdiAccountGroup} size={1} className='me-2' 
                                title="Clientes cadastrados"/>Clientes
                        </Link>
                    </li>

                    <li className="nav-item">
                        <Link to="/app/admin/prestadores" className={props.page === "prestadores" ? activeLink : inactiveLink} aria-current="page">
                            <Icon path={mdiStorefront} size={1} className='me-2'
                                title="Prestadores cadastrados"/>Prestadores
                        </Link>
                    </li>

                    <li className="nav-item">
                        <Link to="/app/admin/categorias" className={props.page === "categorias" ? activeLink : inactiveLink} aria-current="page">
                            <Icon path={mdiShapePlus} size={1} className='me-2'
                                title="Categorias cadastradas"/>Categorias
                        </Link>
                    </li>

                    {/* ******* menu perfil ******** */}
                    <li className="nav-item">
                        <Link to="/app/admin/perfil" className={props.page === "perfil" ? activeLink : inactiveLink} aria-current="page">
                            <Icon path={mdiAccountCircle} size={1} 
                                title="Acessar seus dados pessoais"
                            /> Perfil
                        </Link> 
                    </li>
                    {/* ******* menu perfil ******** */}
                </ul>
            </div>

            {/* Menu horizontal inferior para dispositivos móveis */}
            {isMobile && (
                <div className="bottom-menu d-flex justify-content-between align-items-center bg-secondary p-1 fixed-bottom" style={{ height: '50px' }}>
                    {/* Botões do menu horizontal */}
                    <Link to="/app/admin/home" className={props.page === "home" ? activeLink : inactiveLink}>
                        <Icon path={mdiHome} size={1}
                            title="Página principal/Dashboard"/>
                    </Link>

                    <Link to="/app/admin/clientes" className={props.page === "clientes" ? activeLink : inactiveLink}>
                        <Icon path={mdiAccountGroup} size={1}
                            title="/clientes cadastrados"/>
                    </Link>

                    <Link to="/app/admin/prestadores" className={props.page === "prestadores" ? activeLink : inactiveLink}>
                        <Icon path={mdiStorefront} size={1}
                            title="Prestadores cadastrados"/>
                    </Link>

                    <Link to="/app/amdin/categorias" className={props.page === "categorias" ? activeLink : inactiveLink}>
                        <Icon path={mdiShapePlus} size={1}
                            title="Categorias cadastradas"/>
                    </Link>

                    {/* ******* menu perfil ******** */}
                    <Link to="/app/admin/perfil" className={props.page === "perfil" ? activeLink : inactiveLink} aria-current="page">
                        <Icon path={mdiAccountCircle} size={1} 
                            title="Acessar seus dados pessoais"
                        />
                    </Link> 
                    {/* ******* menu perfil ******** */}
                </div>
            )}
        </>
    );
}

export default AMenu;